import { Fade, Box, Grid, Typography, useTheme } from '@mui/material';

import GroupCard from '@/components/GroupCard';
import { TLifeEventType } from '@/types/ProfileBuilder/profileBuilder';
import { AuthStore } from '@/stores/index';
import { Group } from '@/types/Content/Group';
import { useEffect, useState } from 'react';
import { DiscoverCTA } from '@/components/SubscribedGroupsMagnet/SubscribedGroupsMagnet.styles';
import { observer } from 'mobx-react-lite';

type Props = {
  lifeEvent: TLifeEventType;
  items: Group[];
  matchesXl: boolean;
};

const LifeEventGroups = ({ lifeEvent, items, matchesXl }: Props) => {
  const theme = useTheme();

  const maxItems = matchesXl ? 6 : 4;

  const [showMoreVisible, setShowMoreVisible] = useState(
    () => items.length > maxItems,
  );

  useEffect(() => {
    setShowMoreVisible(items.length > maxItems);
  }, [items.length, maxItems]);

  return (
    <Fade
      in
      easing={{ enter: 'ease-in-out' }}
      timeout={1000}
      key={lifeEvent.id}
    >
      <div>
        <Typography
          variant="h4"
          fontSize={theme.spacing(4.75)}
          lineHeight={1.15}
        >
          {lifeEvent.title}
        </Typography>
        <Typography variant="body2" lineHeight={1.4}>
          {lifeEvent.description}
        </Typography>
        <Grid container spacing={4} mt={theme.spacing(0)}>
          {(showMoreVisible ? items.slice(0, maxItems) : items).map((group) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={12}
              lg={6}
              xl={AuthStore.isLoggedIn ? 4 : 3}
              key={group.groupId}
              display="flex"
              flexDirection="column"
            >
              <Box overflow="hidden" flex={1}>
                <GroupCard
                  slug={group.slug}
                  users={group.users}
                  groupName={group.name}
                  groupId={group.groupId}
                  totalUsers={group.totalUsers || group.userCount}
                  groupDescription={group.description}
                  groupImage={group.image}
                />
              </Box>
            </Grid>

            // <ContentWrapper key={group.groupId}>
            //   <GroupInfoWrapper>
            // <GroupCard
            //   slug={group.slug}
            //   users={group.users}
            //   groupName={group.name}
            //   groupId={group.groupId}
            //   totalUsers={group.totalUsers}
            //   groupDescription={group.description}
            //   groupImage={group.image}
            // />

            //     <GroupInfoCarouselWrapper>
            //       <TileCarousel
            //         arrowColor="black"
            //         defaultSlidesToShow={2}
            //         villageId={currentVillageId}
            //         contentList={group.content}
            //         isSupporterMember={userRole === BASE_USER_ROLES.SUPPORTER}
            //       />
            //     </GroupInfoCarouselWrapper>
            //   </GroupInfoWrapper>
            // </ContentWrapper>
          ))}
        </Grid>
        {showMoreVisible && (
          <DiscoverCTA onClick={() => setShowMoreVisible(false)}>
            Show More
          </DiscoverCTA>
        )}
      </div>
    </Fade>
  );
};

export default observer(LifeEventGroups);
